var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._t("default"),_c('span',[_c('icon',{staticClass:"option-color w-4 h-4",attrs:{"name":"tick"}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }